export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-ink-10 mt-24 bg-paper"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="font-serif-display text-xl text-ink">PDF Review</div>
          <p className="text-sm text-ink-70 mt-2 max-w-sm">
            Review the right way for this PDF. Upload once, we detect the type and run the
            matching playbook.
          </p>
        </div>
        <div className="text-sm text-ink-70 space-y-2">
          <div className="eyebrow mb-2">Playbooks</div>
          <div>NDA · MSA · Lease · Invoice · Resume · Insurance</div>
        </div>
        <div className="text-sm text-ink-70 space-y-2 md:text-right">
          <div className="eyebrow mb-2">pdf-review.com</div>
          <div className="text-ink-50 text-xs max-w-sm md:ml-auto">
            Document review assistance, not legal, tax, or professional advice. Always
            consult a qualified professional for high-stakes decisions.
          </div>
        </div>
      </div>
    </footer>
  );
}
